import {awsFetchRest} from 'utils/asyncUtils'

class ChangeEmailService {
  static changeEmail = (token, email, sub, lang) =>
    awsFetchRest(
      `${process.env.REACT_APP_IDENTITY_SERVICE_URL}/accounts/${encodeURIComponent(sub)}/update-email`,
      'POST',
      {email, lang},
      {Authorization: `Bearer ${token}`}
    )

  static verifyChangeEmail = (ticket, lang) =>
    awsFetchRest(`${process.env.REACT_APP_IDENTITY_SERVICE_URL}/accounts/update-email/${ticket}`, 'POST', {lang})

  static getNewEmail = async (sub, token) =>
    awsFetchRest(
      `${process.env.REACT_APP_IDENTITY_SERVICE_URL}/accounts/${encodeURIComponent(sub)}/update-email/new-email`,
      'GET',
      null,
      {
        Authorization: `Bearer ${token}`,
      }
    )

  static resend = (sub, token, lang) =>
    awsFetchRest(
      `${process.env.REACT_APP_IDENTITY_SERVICE_URL}/accounts/${encodeURIComponent(sub)}/update-email/resend`,
      'POST',
      {lang},
      {Authorization: `Bearer ${token}`}
    )
}

export default ChangeEmailService
